import { connect } from "react-redux";
import App from "../components/App";
import tail from "lodash/tail";
import { loadAttributes } from "../actions/SegmentCreation";

import {
  sendLogin,
  showForgotPassword,
  forgotPassword,
  logout,
  resetPassword,
  closeLoginDialog,
  setEmail,
  setPassword,
  mountSession,
  validateSession,
  showLoginDialog,
  selectClient,
  getUserClients,
  getCurrentUserClients,
  getCurrentUserProfile,
  getUserAvatar,
  getClientInfo,
  clearClientInfo,
  getAPIBuildNumber,
  getDisabledFeatures,
  getCurrentUserOptimizeDetail,
} from "../actions/App";
import { selectedSegment } from "../actions/SegmentList";
function mapStateToProps(state) {
  const {
    loginDialog,
    forgotPassword,
    loggedIn,
    email,
    password,
    userId,
    token,
    roleId,
    roleName,
    loginErrorMessage,
    loadingOptimizeUserDetail,
    tokenExpirationTime,
    clients,
    selected_client,
    loginUserDetail,
    optimizeUserDetail,
    avatar,
    client_info,
    apiBuildNumber,
    disabledFeatures,
  } = state.app;
  const { categories } = state.segmentCreation;
  const demographic = categories ? tail(categories) : undefined;
  return {
    loginDialog,
    disabledFeatures,
    forgotPassword,
    email,
    demoAttributes: demographic,
    password,
    loggedIn,
    userId,
    roleId,
    roleName,
    clients,
    selected_client,
    token,
    loginUserDetail,
    optimizeUserDetail,
    loadingOptimizeUserDetail,
    getUserAvatar,
    tokenExpirationTime,
    loginErrorMessage,
    avatar,
    client_info,
    apiBuildNumber,
    location: {
      path: state.routing.location.pathname,
      queryStep: state.routing.location.match
        ? state.routing.location.match.params.step
        : "",
      query: state.routing.location.match
        ? state.routing.location.match.params
        : null,
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDisabledFeatures: () => {
      dispatch(getDisabledFeatures());
    },
    mountSession: (session) => {
      dispatch(mountSession(session));
    },

    handleLoginClose: () => {
      dispatch(closeLoginDialog());
    },

    handleLoginSubmit: (email, password) => {
      dispatch(sendLogin(email, password));
    },

    handleLogout: () => {
      window.localStorage.clear();
      dispatch(logout());
    },

    handleForgotPassword: () => {
      dispatch(showForgotPassword());
    },

    handleForgotPasswordSubmit: (email) => {
      dispatch(forgotPassword(email));
    },

    handleResetPassword: (token, email, password) => {
      dispatch(resetPassword(token, email, password));
    },

    setEmail: (email) => {
      dispatch(setEmail(email));
    },

    setPassword: (password) => {
      dispatch(setPassword(password));
    },

    validateSession: () => {
      dispatch(validateSession());
    },

    selectClient: (value) => {
      dispatch(selectClient(value));
    },
    showLoginDialog: () => {
      dispatch(showLoginDialog());
    },
    getUserClients: (id) => {
      dispatch(getUserClients(id));
    },
    getUserDetail: (id) => {
      dispatch(getCurrentUserProfile());
    },
    getOptimizeUserDetail: () => {
      dispatch(getCurrentUserOptimizeDetail());
    },
    getUserAvatar: (filerName) => {
      dispatch(getUserAvatar(filerName));
    },
    getCurrentUserClients: () => {
      dispatch(getCurrentUserClients());
    },
    getClientInfo: (id) => {
      dispatch(getClientInfo(id));
    },
    clearClientInfo: () => {
      dispatch(clearClientInfo());
    },
    getAPIBuildNumber: () => {
      dispatch(getAPIBuildNumber());
    },
    selectedSegment: (value) => {
      dispatch(selectedSegment(value));
    },
    loadAttributes: (cid) => {
      dispatch(loadAttributes(cid));
    },
  };
}

const AppContainer = connect(mapStateToProps, mapDispatchToProps)(App);

export default AppContainer;



// WEBPACK FOOTER //
// ./src/containers/App.js